export default "__VITE_ASSET__Dzyb_7UT__"